export default __webpack_public_path__ + "static/media/banner-mais-premiavel-mobile.e1d7b96f.png";